import { ChangeDetectionStrategy, Component } from "@angular/core";
import { AppInitService } from "../../../commons/src/lib/services/app-init.service";
import { OstUploadCoordinatorService } from "../../../commons/src/lib/services/ost-upload-coordinator.service";
import { UserStore } from "../../../commons/src/lib/stores/user.store";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent {
  protected readonly isAuthenticating = this.userStore.isAuthenticating;

  constructor(
    private readonly appInitService: AppInitService,
    private readonly userStore: UserStore,
    private readonly ostFileUploadCoordinator: OstUploadCoordinatorService
  ) {
    this.ostFileUploadCoordinator.start();
  }
}
